import { z } from 'zod';
import { nameSchema } from '../address/create-input.js';
import { refineRemitRequiredWhenDistinct } from '../address/refine-remit-required-when-distinct.js';
import { vendorAddressPairLocationFields } from './pair-location-fields.js';
// Shipping is always written as default — callers must not send defaultFlag.
export const createVendorShippingAndRemitToAddressesInputSchema = z
    .object({ name: nameSchema, ...vendorAddressPairLocationFields })
    .superRefine(refineRemitRequiredWhenDistinct);
//# sourceMappingURL=create-pair-input.js.map